//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Stars from './_stars'
import F2 from '@antv/f2'
import PieLabel from '@antv/f2/lib/plugin/pie-label'
import WX_API from '@/utils/wx_api'
import FoldBtn from './_fold_btn'
F2.Chart.plugins.register(PieLabel)
export default {
    props: {
        plate: {
            type: Object
        },
        presell_data: {
            type: Object
        }
    },
    components: {
        Stars,
        FoldBtn
    },
    watch: {
        plate (plate) {
            if (plate.areas && plate.areas.length) {
                setTimeout(() => {
                    this.initChart(plate.areas)
                })

            }
        }
    },
    data () {
        return {
            show_all_presell: false
        }
    },
    computed: {
        show_presell () {
            if (this.show_all_presell) {
                return this.presell_data.items
            }
            return this.presell_data.items && this.presell_data.items.length ? this.presell_data.items.slice(0, 3) : []
        },
        main_area () {
            const { areas } = this.plate
            if (areas && areas.length) {
                return areas.reduce((prev, item) => {
                    if (item.percentage > prev.percentage) {
                        return item
                    }
                    return prev
                }, {
                    percentage: 0
                })
            }
        }
    },
    methods: {
        async toggleShowPresell () {
            if (this.show_all_presell) {
                const res = await WX_API.getElementPosition('#price_header', this.$mp.component)
                 if (!res) {
                    return
                }
                const { top, scrollTop } = res
                const offset_y = top + scrollTop
                if (offset_y) {
                    wx.pageScrollTo({
                        scrollTop: offset_y,
                        success: () => {
                            this.show_all_presell = false
                        }
                    })
                }
            } else {
                this.show_all_presell = true
            }
        },
        initChart (areas) {
            const node = document.querySelector(`#area-chart`)
            const { width, height } = node
            const context = node.getContext('2d')
            const pixelRatio = wx.getSystemInfoSync().pixelRatio
            // 高清设置
            node.width = width * pixelRatio
            node.height = height * pixelRatio
            const config = { context, width, height, pixelRatio }
            const chart = new F2.Chart({
                ...config
            })
            chart.coord('polar', {
                transposed: true,
                radius: 0.8,
                innerRadius: 0.6
            })
            const area_data = areas.map((item) => {
                return {
                    ...item,
                    const: 'const'
                }
            }).sort((a, b) => {
                return a.percentage - b.percentage
            })
            console.log(area_data)
            chart.source(area_data)
            chart.axis(false)
            chart.tooltip(false)
            chart.legend(false)
            console.log(chart)
            chart.interval()
                .position('const*percentage')
                .adjust('stack')
                .color('area', [ '#A2D9ED', '#63BFBC', '#7BCC51', '#C9C950', '#98A6EB' ])
            chart.pieLabel({
                sidePadding: 10,
                label1OffsetY: -2,
                label2OffsetY: 2,
                inflectionOffset: 5,
                anchorOffset: 3,
                label1: function label1(data) {
                    return {
                        text: data.area,
                        fill: '#343434',
                        fontWeight: 'bold'
                    };
                },
                label2: function label2(data) {
                    return {
                        text: data.percentage + '%',
                        fill: '#999'
                    };
                }
            })
            chart.render()
            if (chart) {
                this.chart = chart;
                this.canvasEl = chart.get('el');
            }
        }
    }
}
